import React from 'react';
import * as constant from './constants';
import Ribbon from './../Ribbon';
import Button from './../Button';
import ImageButton from './../Button/ImageButton';
import UtilsProfile from "../../utils/Profile";

import Asset from "../../requests/apa/Asset";
import Translator from './../../requests/apa/Translator';
import ProfileReadCache from '../../AAF/LoaderExp/ProfileReadCache';

export const Start = ({ props }) => {

  let items = props.items;
  let adminProfile = UtilsProfile.getAdminMember(items);

  //RDN Solo se agrega este boton si son menos de cuatro los elementos
  
  if (items && items.length && ((props.maxMembers - items.length) >= 1)) {
    let admin = UtilsProfile.getAdminMember(items);
    
    items.push({
      name: Translator.get('add_profile_label', 'Agregar Perfil'),
      imgSrc: UtilsProfile.getAddAvatar(),
      data: admin.data,
      clickHandler: (item) => {
        if (item.data && item.data.change_name) {
          props.onSetAction(constant.COMPLETE_PROFILE, item.data);
        }
        else {
          if(!ProfileReadCache.getEnableClick()){
            return;
          }
          props.onSetAction(constant.ADD_PROFILE);
        }
      }
    });
  }  

  UtilsProfile.setFocus('.container.profile .row.avatar-option .focusable');

  return (
    <div className='container profile'>
      <div className='row'>

      </div>
      <div className='row title'>
        <span>
          {Translator.get('view_profiles_title', '¿Quien esta viendo ahora?')}
        </span>
      </div>
      <div className='row avatar-option'>
        <div className='container'>{getAvatars(items)}</div>
      </div>
      <div className='row button'>
        <Button order={['text']} className='button' text={Translator.get('manage_profiles_btn', 'Administrar Perfiles')}
          onClick={() => {            
            props.onSetAction(constant.ADMIN_PROFILE);
          }} />
      </div>
    </div>
  );
};


const getAvatars = (items) => {

  if (items && items.length) {
    return items.map((item) => {
      
      let imgSrc = `${item.imgSrc}${UtilsProfile.getAddAvatar() === item.imgSrc ? '' :'&impolicy=resize&vwidth=150'}` || Asset.get('placeholder_profile', '/images/placeholder_talent_movie.png');
      
      return (
        <div className='image'>
          <ImageButton order={['text']} className='button' imgSrc={imgSrc}
            key={item.partnerUserId}
            text={item.name}            
            onClick={(e) => {              
              item.clickHandler(item);
            }}
            onBlur={() => console.log('onBlur')}
          />
        </div>
      );
    });
  }
  else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Profile/Start.jsx